const DATE_FORMAT_TYPE = {
  ddMMyyyy: "dd-MM-yyyy",
  MMyyyy: "MM-yyyy",
  yyyyMM: "yyyy-MM",
};

export default DATE_FORMAT_TYPE;
